import React, {memo} from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import Table from "tabloom/build/table"

/** @typedef {object} CardTableTableProps */

/** @typedef {object} CardTableTableState */

/**
 * @extends {ShapeComponent<CardTableTableProps, CardTableTableState>}
 */
class CardTableTable extends ShapeComponent {
  render() {
    return (
      <Table {...this.props} />
    )
  }
}

export default memo(shapeComponent(CardTableTable))
